"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var resize_observer_polyfill_1 = tslib_1.__importDefault(require("resize-observer-polyfill"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var _utilities_1 = require("../../../utilities");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n"])));

var AbsolutePositioner = function (_a) {
  var children = _a.children;

  var _b = react_1["default"].useState(0),
      height = _b[0],
      setHeight = _b[1];

  var wrapperRef = react_1["default"].useRef(null);

  _utilities_1.useIsomorphicLayoutEffect(function () {
    var wrapperEl = wrapperRef.current;

    if (!wrapperEl) {
      return;
    } // initial height


    setHeight(wrapperEl.getBoundingClientRect().height); // subsequent updates

    var resizeObserver = new resize_observer_polyfill_1["default"](function (entries) {
      for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var entry = entries_1[_i];
        setHeight(entry.contentRect.height);
      }
    });
    resizeObserver.observe(wrapperEl);
    return function () {
      resizeObserver.unobserve(wrapperEl);
      resizeObserver.disconnect();
    };
  }, []);

  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(Wrapper, {
    ref: wrapperRef
  }, children), react_1["default"].createElement("div", {
    style: {
      height: height
    }
  }));
};

exports["default"] = AbsolutePositioner;
var templateObject_1;